export default "__VITE_ASSET__de94979b__"